// export const urlPath = {
//   mainPath: "http://localhost:2000/sura/",
// };

export const urlPath = {
  mainPath: "https://saccoteau.co.ke/sura/",
};
